<template>
  <a-select v-model="formData[filterKey + '_condition']" style="width: 38px;margin-right:3px" :showArrow="false">
    <a-select-option v-if="!hiddenOpts.includes('equals')" value="equals">=</a-select-option>
    <a-select-option v-if="!hiddenOpts.includes('not_equals')" value="not_equals">!=</a-select-option>
  </a-select>
</template>

<script>
export default {
  name: 'FilterCondition',
  props: {
    formData: Object,
    filterKey: String,
    hiddenOpts: {
      type: Array,
      default: () => ([]),
    },
  },
}
</script>
